export default "__VITE_ASSET__ffcc4616__"